import styles from "./styles.module.scss";
import Page from "../../../Components/Page";
import React from "react";

import { createContext, useContext } from "react";
import { useAmplitudeTracking } from "Services/Hooks/useAmplitudeTracking";

// Define context type
interface InstallTrackingContextType {
  trackInstall: (eventProperties: Record<string, string>) => void;
}

// Create context with correct default
const InstallTrackingContext = createContext<InstallTrackingContextType>({
  trackInstall: () => {},
});

export const useInstallTracking = () => useContext(InstallTrackingContext);
const InstallWrapper = ({ children }: { children: React.ReactNode }) => {
  const track = useAmplitudeTracking();

  const trackInstall = (eventProperties: Record<string, string>) => {
    track("Install", { ...eventProperties, install_location: "web" });
  };

  return (
    <InstallTrackingContext.Provider value={{ trackInstall }}>
      <Page className={styles.page}>{children}</Page>
    </InstallTrackingContext.Provider>
  );
};

export default InstallWrapper;
